const Resource = {

    // FIELDS
    "premise": "Premise",
    "name": "Name",
    "status": "Status",
    "record_status": "Record Status",
    "opening_time": "Opening Time",
    "closing_time": "Closing Time",
    "slot_duration": "Slot Duration",
    "max_slots": "Max Number of Booking for Slot",
    "capacity": "Capacity",
    "description": "Description",
    "access_type": "Access Type",
    "public": "Public",
    "private": "Private",
    "search": "Search",

    // STATUS
    "status_available": "Available",
    "status_not_available": "Not Available",
    "status_maintenance": "Maintenance",

    // PAGE HEADER
    "resource": "Resource",
    "slot_availability": "Slot Availability",
    "booking_summary": "Booking Summary",
    "time_slots": "Time Slots",
    "today": "Today",
    "tomorrow": "Tomorrow",
    "total_slots": "Total Slots",
    "available_slots": "Available Slots",
    "booked_slots": "Booked Slots",
    "no_slots_available": "No slots available for the selected date",
    "error_load_details": "Something went wrong, can't load resource details",

    // ERROR
    "error_premise": "Select Premise",
    "error_name": "Enter Name",
    "error_status": "Select Status",
    "error_opening_time": "Select Opening Time",
    "error_closing_time": "Select Closing Time",
    "error_closing_before_opening": "Closing time must be after opening time",
    "error_slot_duration": "Select Slot Duration",
    "error_max_slots": "Enter Max Number of Booking",
    "error_capacity": "Enter Capacity",
    "error_access_type": "Select Public or Private",
    "error_min": "Value must be at least 1",

    // TABLE HEADER
    "table_premise": "PREMISE",
    "table_name": "NAME",
    "table_status": "STATUS",
    "table_opening_time": "OPENING TIME",
    "table_closing_time": "CLOSING TIME",
    "table_slot_duration": "SLOT DURATION",
    "table_max_slots": "MAX BOOKING",
    "table_capacity": "CAPACITY",

}

export default Resource;